export default __webpack_public_path__ + "static/Group 14-434be6b33564f87d4a51f0eaf1cc4ee1.png";